var $boolSelecionarTodosCreditosCliente = false;
var usuarioLogado = global.sessionStorage.getData('UsuarioLogado')

window.CreditoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-listar-credito-item",
    tagName: "tr",
    className: "clicavel",

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent,
        this.controller = options.controller;

        if (!usuarioLogado || !(usuarioLogado && usuarioLogado.CorFundo || usuarioLogado.CorTexto)) {
            usuarioLogado = { CorFundo: "#FFFFCC", CorTexto: "#000000" };
        } 
    },

    events: {
        'click td': "selecionarCreditoCliente"
    },

    selecionarCreditoCliente: function (e) {

        var cor = $(e.target).parents("tr").css("background-color");

        if (e.clientX !== null) { // Click linha
            if (cor === "rgb(255, 255, 255)" || cor === "transparent" || cor === "rgba(0, 0, 0, 0)") {
                $(e.target).parents("tr").css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
                //this.controller.model = this.model;
                this.parent.parent.adicionarCreditoCliente(this.model);
            } else {
                $(e.target).parents("tr").css({ "background-color": '', "color": '' });
                this.parent.parent.removerCreditoCliente(this.model);
            }
        } else { //Selecionar Todos
            if ($boolSelecionarTodosCreditosCliente) {
                if (cor === usuarioLogado.CorFundo || cor === "transparent" || cor === "rgba(0, 0, 0, 0)") {
                    $(e.target).parents("tr").css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
                    this.controller.model = this.model;
                    this.parent.parent.adicionarCreditoCliente(this.model);
                }
            } else {
                $(e.target).parents("tr").css({ "background-color": '', "color": '' });
                this.parent.parent.removerCreditoCliente(this.model);
            }
        }
    },

});

window.CreditoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-credito",
    childView: CreditoItemView,
    childViewContainer: "#lista-credito-container",

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
    },

    events: {
        'click #selecionar-todos-creditos-cliente': "selecionarTodosCreditosCliente",
    },

    buildChildView: function (item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });

        if (this.controller) {
            view.controller = this.controller;
        }

        return view;
    },

    selecionarTodosCreditosCliente: function (e) {
        if ($boolSelecionarTodosCreditosCliente)
            $boolSelecionarTodosCreditosCliente = false;
        else
            $boolSelecionarTodosCreditosCliente = true;

        $("#lista-credito-container td.codigo").trigger("click");
    },
});